import type { Organization } from '@unhead/schema-org'
import { defineImage } from '@unhead/schema-org/vue'
import {
    addressesCard,
    contacts,
    email,
    socialMedias,
} from '~/const/company-info.consts'
import type { Image } from '~/types/global.types'

export function getSeoOrganizationId() {
    const config = useRuntimeConfig()

    return `https://www.${config.public.website}/#/schema/Organization/`
}

export function getSeoOrganizationReference() {
    return {
        '@id': getSeoOrganizationId(),
    }
}

export function getSeoOrganization() {
    const config = useRuntimeConfig()
    const website = config.public.website
    const address = addressesCard[website]
    const id = getSeoOrganizationId()
    const getImageUrl = (url: string) =>
        url.startsWith('http') ? url : `https://www.${website}${url}`
    const organization: Organization = {
        '@id': id,
        '@type': ['LocalBusiness'],
        name: 'Кроми',
        alternateName: 'Cromi',
        legalName: 'ООО «Кроми»',
        // url: `https://www.${website}`, //дублируется, потому что пакет автоматом добавляет
        description: '',
        image: address[0].images.map((image) => getImageUrl(image.url)),
        sameAs: socialMedias.map((item) => item.link),
        telephone: contacts.ru.tel,
        email: email,
        foundingDate: '2010-02-10',
        // logo: {
        //     '@type': 'ImageObject',
        //     url: '/BS_logo_full_line_violet.png',
        // },
        address: {
            '@type': 'PostalAddress',
            addressCountry: 'RU',
            addressRegion: 'Северо-Западный федеральный округ',
            addressLocality: contacts.spb.title,
            streetAddress: contacts.spb.address,
            postalCode: '195197',
        },
        geo: {
            '@type': 'GeoCoordinates',
            latitude: 59.981073,
            longitude: 30.378813,
        },
        // contactPoint: Object.values(contacts).map((item) => ({
        //     '@type': 'ContactPoint',
        //     telephone: item.tel,
        //     contactType: item.address,
        //     contactOption: 'TollFree',
        //     areaServed: ['RU'],
        //     availableLanguage: ['Russian'],
        // })),
        serviceArea: {
            '@type': 'Country',
            name: 'Россия',
        },
        currenciesAccepted: 'RUB',
        paymentAccepted: 'Безналичная оплата, Наличная оплата',
        priceRange: '$$',
        openingHoursSpecification: [
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: [
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                ],
                opens: '09:30',
                closes: '18:30',
            },
        ],
    }

    switch (website) {
        case 'cromi.ru':
            organization.description =
                'Поставка, консультирование и дистрибуция оборудования для экскурсионных и деловых мероприятий: радиогиды, аудиогиды, оборудование и кабины для синхронного перевода, конференц-системы и аппаратура для сферы «Доступная среда».'
            // organization.review = {
            //     '@type': 'Review',
            //     reviewBody:
            //         'При работе с группами, даже небольшими, наличие радиооборудования выводит экскурсию на новый уровень комфорта. Я работала с разными поставщиками, имею возможность сравнивать. Компания Кроми номер один для меня. Отличная слышимость, моментальная самонастройка приемника на ретранслятор, вменяемая дистанция улавливания сигнала, оперативная работа менеджеров. Спасибо за качественное оборудование и сервис, обязательно буду пользоваться и дальше!',
            //     datePublished: '2024-08-20',
            //     author: {
            //         '@type': 'Person',
            //         name: 'Stacey Duncliff',
            //     },
            //     reviewRating: {
            //         '@type': 'Rating',
            //         ratingValue: 5,
            //     },
            //     itemReviewed: defineOrganization({
            //         '@id': id
            //     })
            // }
            // organization.department['review'] = {
            //     '@type': 'Review',
            //     reviewBody:
            //         'Приобрели аудиогиды А-5 для картинной галереи. Оборудование качественное. Звук чистый, слышно идеально. Пользуются посетители разных стран и все понимают',
            //     datePublished: '2025-01-27',
            //     author: {
            //         '@type': 'Person',
            //         name: 'Ольга Черкесова',
            //     },
            //     reviewRating: {
            //         '@type': 'Rating',
            //         ratingValue: 5,
            //     },
            //     itemReviewed: defineOrganization({
            //         '@id': idDepartment
            //     })
            // }

            // organization['aggregateRating'] = defineAggregateRating({
            //     ratingCount: 4.9,
            //     reviewCount: 34
            // })
            // organization.department['aggregateRating'] = defineAggregateRating({
            //     ratingCount: 4.9,
            //     reviewCount: 26
            // })
            break
        case 'cromi.rent':
            organization.description =
                '15 лет в сфере проката. Аренда оборудования для технического обеспечения деловых мероприятий под ключ.  Аренда радиогидов и аудиогидов для экскурсий. Офисы и склады в Санкт-Петербурге и Москве. Работаем по всей России.'
            // organization.review = {
            //     '@type': 'Review',
            //     reviewBody:
            //         'Отличный сервис по аренде. Очень лояльные сотрудники, легко входят в положение, оперативно отвечают и направляют документы. Оборудование работает без перебоев, порекомендовала сервис всем своим коллегам. Спасибо!!',
            //     datePublished: '2024-02-24',
            //     author: {
            //         '@type': 'Person',
            //         name: 'РПГ На Высоте, Екатерина и Анастасия',
            //     },
            //     reviewRating: {
            //         '@type': 'Rating',
            //         ratingValue: 5,
            //     },
            // }
            // organization.department['review'] = {
            //     '@type': 'Review',
            //     reviewBody:
            //         'Как event-агентство сотрудничаем с Cromi с 2021 года. Через них обеспечивали оборудование как для Премии «Вызов», так и для Молодёжного энергетического саммита БРИКС. Всегда впечатляет их профессиональный подход: оборудование заранее тестируется на площадке, мероприятие сопровождают опытные специалисты, а техническая поддержка доступна 24/7 и быстро решает любые вопросы. Огромное спасибо команде Cromi!',
            //     datePublished: '2025-05-30',
            //     author: {
            //         '@type': 'Person',
            //         name: 'Надежда Назарова',
            //     },
            //     reviewRating: {
            //         '@type': 'Rating',
            //         ratingValue: 5,
            //     },
            // }
            break
        case 'radioguide.rent':
            organization.description =
                'Прокат экскурсионных радиосистем тургид в Санкт-Петербурге, Москве и по всей России. Топовое оборудование Reinvox, несколько тысяч приемников и передатчиков.'
            // organization.review = {
            //     '@type': 'Review',
            //     reviewBody:
            //         'Организация мероприятий проходит с очень грамотными менеджерами, по радиогидам очень подробно объяснили! Видно, что компания занимается узкоспециализированной продукцией. Еще и в аренду можно взять. Компанию рекомендую!',
            //     datePublished: '2024-11-21',
            //     author: {
            //         '@type': 'Person',
            //         name: 'Анна Яровикова',
            //     },
            //     reviewRating: {
            //         '@type': 'Rating',
            //         ratingValue: 5,
            //     },
            // }
            // organization.department['review'] = {
            //     '@type': 'Review',
            //     reviewBody:
            //         'Брали оборудование на экскурсию - просто супер! Хорошо слышно, удобно пользоваться. Доставили прямо в гостиницу и забрали из города, когда экскурсия закончилась. Очень удобно!',
            //     datePublished: '2024-07-16',
            //     author: {
            //         '@type': 'Person',
            //         name: 'Мария Садовина',
            //     },
            //     reviewRating: {
            //         '@type': 'Rating',
            //         ratingValue: 5,
            //     },
            // }
            break
    }

    return organization
}

export function defineSeoImage(image: Image) {
    return defineImage({
        url: image.url,
        height: image.height,
        width: image.width,
        caption: image.alt,
        inLanguage: 'ru-RU',
    })
}
export function defineShippingDetails() {
    const config = useRuntimeConfig()

    if (config.public.website == 'cromi.rent') return null
    return {
        '@type': 'OfferShippingDetails',
        hasShippingService: {
            '@type': 'ShippingService',
            name: 'Деловые линии',
            shippingConditions: {
                '@type': 'ShippingConditions',
                deliveryTime: {
                    '@type': 'ShippingDeliveryTime',
                    businessDays: {
                        '@type': 'OpeningHoursSpecification',
                        dayOfWeek: [
                            'Monday',
                            'Tuesday',
                            'Wednesday',
                            'Thursday',
                            'Friday',
                        ],
                    },
                    handlingTime: {
                        '@type': 'QuantitativeValue',
                        minValue: 0,
                        maxValue: 1,
                        unitCode: 'DAY',
                    },
                    transitTime: {
                        '@type': 'QuantitativeValue',
                        minValue: 1,
                        maxValue: 5,
                        unitCode: 'DAY',
                    },
                },
                shippingRate: {
                    '@type': 'MonetaryAmount',
                    minValue: '883',
                    maxValue: '1359',
                    currency: 'RUB',
                },
                shippingDestination: {
                    '@type': 'DefinedRegion',
                    addressCountry: 'RU',
                    name: 'Russia',
                },
            },
        },
    }
}
export function defineSeoAggregateRating() {
    return {
        '@type': 'AggregateRating',
        ratingValue: '4,9',
        reviewCount: '34',
    }
}
export function defineMerchantReturnPolicy() {
    return {
        '@type': 'MerchantReturnPolicy',
        applicableCountry: 'RU',
        returnPolicyCategory:
            'https://schema.org/MerchantReturnFiniteReturnWindow',
        merchantReturnDays: 14,
        returnMethod: 'https://schema.org/ReturnByMail',
        returnFees: 'https://schema.org/FreeReturn',
    }
}
// utils/schema.ts
export type PropertyValue = {
    '@type': 'PropertyValue'
    name: string
    value: string
}

/**
 * Превращает HTML-список (<ul>/<ol>) с <li> в additionalProperty[]
 * Правила:
 * - если <li> содержит ":", левая часть -> name, правая -> value
 * - если ":" нет, то name = вся строка, value = "Да"
 */
export function defineSeoAdditinalProperties(
    html: string | null
): PropertyValue[] {
    if (!html || typeof html !== 'string') return []

    // Быстрый парсер <li> без внешних зависимостей
    const liRegex = /<li\b[^>]*>([\s\S]*?)<\/li>/gi
    const items: PropertyValue[] = []

    const decodeEntities = (s: string) => {
        if (!s) return ''
        const map: Record<string, string> = {
            '&nbsp;': ' ',
            '&#160;': ' ',
            '&amp;': '&',
            '&lt;': '<',
            '&gt;': '>',
            '&quot;': '"',
            '&#39;': "'",
            '&ndash;': '–',
            '&mdash;': '—',
        }
        return s.replace(
            /(&nbsp;|&#160;|&amp;|&lt;|&gt;|&quot;|&#39;|&ndash;|&mdash;)/g,
            (m) => map[m] || m
        )
    }

    const normalize = (s: string) =>
        decodeEntities(s)
            .replace(/\s+/g, ' ')
            .replace(/\s*,\s*$/g, '') // хвостовые запятые
            .trim()

    let match: RegExpExecArray | null
    while ((match = liRegex.exec(html)) !== null) {
        const raw = match[1] ?? ''
        const text = normalize(stripHtml(raw))
        if (!text) continue

        // сплит только по ПЕРВОМУ двоеточию (англ ":" или fullwidth "：")
        const colonIdx = text.search(/[:：]/)
        if (colonIdx > -1) {
            const name = normalize(text.slice(0, colonIdx))
            const value = normalize(text.slice(colonIdx + 1))
            if (name) {
                items.push({
                    '@type': 'PropertyValue',
                    name,
                    value: value || 'Да',
                })
            }
        } else {
            items.push({
                '@type': 'PropertyValue',
                name: text,
                value: 'Да',
            })
        }
    }

    return items
}
